module.exports = __webpack_public_path__ + "img/my-meeting-white.ac10c604.svg";